import { Component, inject, OnInit } from '@angular/core';
import {Clipboard} from '@angular/cdk/clipboard';
import { FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NotificationSnack } from '../../../services/notifications/snackbars/notification-snack';
import { Downtime } from '../../../../core/services/times/downtime';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-win-shared',
  imports: [MatDialogTitle, MatDialogContent, 
    MatDialogClose, MatDialogActions, 
    TranslatePipe, MatFormFieldModule, 
    MatInputModule, FormsModule, 
    MatIconModule, MatTooltipModule],
  templateUrl: './win-shared.html',
  styleUrl: './win-shared.scss'
})
export class WinShared implements OnInit {
  readonly dialogRef = inject(MatDialogRef<WinShared>);
  data = inject(MAT_DIALOG_DATA);

  txtDialog: any;
  copyLink: string = '';
  clipboard = inject(Clipboard);
  translate = inject(TranslateService);
  notification = inject(NotificationSnack);
  downtime = inject(Downtime);
  txtArray: Array<string> = ['Посилання скопійовано!', 'Ссылка скопирована!', 'Link copied!'];


  ngOnInit(): void {
    this.dialogRef.disableClose = true;
    this.copyLink = this.data.link;
    this.translate.get(['shared']).subscribe(translations => {
      this.txtDialog = translations['shared'];
    });
  }

  eventCopyLink(){
    this.downtime.refreshTimer();
    this.clipboard.copy(this.copyLink);
    this.copyLink = this.txtDialog?.txtCopySucc;

    // this.notification.setMessage(this.txtDialog?.txtCopySucc);
    // this.notification.display();
  }

  onNoClick(): void {
    this.downtime.refreshTimer();
    this.dialogRef.close();
  }

  clickIconClose(event: MouseEvent){
    //if(event.layerX > 390 && event.layerX < 417 && event.layerY > 15 && event.layerY < 40){ 
      this.onNoClick();
    //}
  }
}
